import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export const store = new Vuex.Store(
  {
    state:{
      registered:false,
      vulAan:false,
      hokje:"",
      actieveTaak:"",
      actieveLes:"",
      actievePlanning:"",
      actieveDag:"",
      actieveDagZin:"",
      agendaPunten:[],
      actieveDatumBestaat:false,
      actieveKey:""

    },
    getters:{
      actieveTaak:state =>{
        return state.actieveTaak
      },
      actieveLes:state =>{
        return state.actieveLes
      },
      actievePlanning:state =>{
        return state.actievePlanning
      },
      agendaPunten:state =>{
        return state.agendaPunten
      }
    },
    mutations:{
      setActieveDatumBestaat(state,waarde){
        console.log("Datuminstellen")
        state.actieveDatumBestaat= waarde
      },
      setActieveKey(state,waarde){
        state.actieveKey= waarde
      },
    }



  }
)



// WEBPACK FOOTER //
// ./src/store/store.js